import React from 'react'
import {
  CFView,
  CFText,
  CFImage,
  CFLink,
  DefaultScreen,
  MobileScreen,
} from 'components'
import Header from './Header'
import OrderPickupButton from './OrderPickupButton'
import OrderDeliveryButton from './OrderDeliveryButton'
import { hero, heroText, mobileHero, mobileHeroText } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView
          h="100vh"
          image={`url(${mobileHero}) top / cover no-repeat`}
          column
          alignCenter
          justifyStart
          textCenter
        >
          <CFImage
            w="95%"
            mt="32%"
            src={mobileHeroText}
            alt="Dami Japanese Restaurant hero text"
            zIndex={98}
          />
          <CFView pulsate mt="15px">
            <OrderPickupButton />
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          h="68vh"
          maxHeight="480px"
          image={`url(${hero}) bottom / cover no-repeat`}
          zIndex={90}
          column
          justifyCenter
          alignStart
        >
          <CFView column justifyCenter alignStart ml="150px">
            <CFImage
              h="45vh"
              maxHeight="250px"
              src={heroText}
              alt="Dami Japanese Restaurant hero text"
              zIndex={98}
            />
            <CFView pulsate ml="10px">
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
